import React, { useEffect, useMemo, useRef, useState, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";

const SelectedUser = (props) => {
    const userSelector = useSelector((store) => store.user);

    const { disabled } = props;
    const renderUsers = useMemo(() => {
        const users = props?.assignedUser;
        const render = users.map((rowData, index) => {
            let completed;

            switch (rowData.complete) {
                case "Y":
                    completed = <span className={"rev-end"}>Comment End</span>;
                    break;
                case "C":
                    completed = <span className={"rev-complete"}>Completed</span>;
                    break;
                case "I":
                    completed = <span className={"rev-ing"}>In-progress</span>;
                    break;
                case "N":
                    completed = <span className={"rev-not"}>Not started</span>;
                    break;
                default:
                    completed = <span className={"rev"}>N/A</span>;
            }

            return (
                <tr key={"assignedUsers" + index} data-id={rowData.userId}>
                    <td>{rowData.userId}</td>
                    <td>{rowData.userNm}</td>
                    <td>{rowData.enDepartmentName}</td>
                    <td className={"text-center"}>{completed}</td>
                    {!disabled && (
                        <td className="text-center">
                            {rowData.userId !== userSelector.userId && (
                                <button
                                    className="bpl-btn danger small"
                                    onClick={props?.removeUser}
                                >
                                    <FontAwesomeIcon icon={faClose}/>
                                </button>
                            )}
                        </td>
                    )}
                </tr>
            );
        });
        return render;
    }, [props]);

    return (
        <div style={{ width: "600px", position: "relative" }}>
            <table
                className={"bpl-table-default small compact-row fixed"}
                style={{ fontSize: "0.9rem" }}
            >
                <colgroup>
                    <col width="120"/>
                    <col/>
                    <col width="220"/>
                    <col width="120"/>
                    <col width="30"/>
                </colgroup>
                <thead>
                    <tr>
                        <th>User Id</th>
                        <th>User Name</th>
                        <th>Department</th>
                        <th>Status</th>
                        {!disabled && <th></th>}
                    </tr>
                </thead>
                <tbody className={"rev-user-tbody"}>
                    {props.assignedUser.length > 0 ? (
                        renderUsers
                    ) : (
                        <tr>
                            <td colSpan="4"> </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default SelectedUser;
